import React, { useState, useEffect } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import Topbar from '../containers/Topbar'
import Aside from '../containers/Aside'
import Container from '../containers/Container'
import { connect } from 'react-redux'
import { lightTheme, darkTheme } from '../assets/styles/theme'
import { GlobalStyles } from '../assets/styles/theme'
import { setThemeApp } from '../actions'
import Loading from '../components/Loading'

const Layout = ({
  children,
  loggedIn,
  topbar,
  setThemeApp,
  loading,
}) => {
  const [toggleBar, setToggleBar] = useState(false)
  const [toggleBarMouse, setToggleBarMouse] = useState(false)
  const toggleBarButton = e => {
    if (e === false) {
      setToggleBar(false)
    }
    setToggleBar(!toggleBar)
  }
  const toggleMouseHover = () => {
    setToggleBarMouse(!toggleBarMouse)
  }
  const title = topbar.title

  const buttonBar = topbar.buttonBar

  useEffect(() => {
    setThemeApp({
      theme: 'light',
      lightTheme,
      darkTheme,
    })
  }, [setThemeApp])

  return (
    <ThemeProvider theme={lightTheme}>
      <GlobalStyles />
      {loading && <Loading />}
      {window.location.pathname !== '/login' && loggedIn ? (
        <Main toggleBar={toggleBar} toggleBarMouse={toggleBarMouse}>
          <Topbar
            theme={false}
            toggleBarButton={toggleBarButton}
            toggleBar={toggleBar}
            toggleBarMouse={toggleBarMouse}
          />
          <Aside
            theme={false}
            toggleBarButton={toggleBarButton}
            toggleBar={toggleBar}
            toggleBarMouse={toggleBarMouse}
            toggleMouseHover={toggleMouseHover}
          />
          <Container title={title} buttonBar={buttonBar}>
            {children}
          </Container>
        </Main>
      ) : (
        <>{children}</>
      )}
    </ThemeProvider>
  )
}

const mapStateToProps = state => {
  return {
    loggedIn: state.reducerApp.loggedIn,
    topbar: state.reducerApp.topbar,
    loading: state.reducerApp.loading,
  }
}

const mapDispatchToProps = {
  setThemeApp,
}

export default connect(mapStateToProps, mapDispatchToProps)(Layout)

const Main = styled.main`
  display: grid;
  width: 100vw;
  transition: all 0.3s ease-in-out;
  grid-template-columns: ${props =>
      props.toggleBar && !props.toggleBarMouse
        ? '80px'
        : '280px'} 1fr;
  grid-template-rows: 75px 1fr;
  grid-template-areas:
    'topbar topbar'
    'aside container';

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    grid-template-rows: 75px 1fr;
    grid-template-areas:
      'topbar'
      'container';
  }
`
